module.exports = __webpack_public_path__ + "img/Selangor.0c08768b.png";